import React, { useState } from "react";
import { Box, Typography, Grid, TextField } from "@mui/material";
import styles from "../InternalTracker/InternalTracker.module.css";
import { customTextColor } from "../../utils/const";
import { RxCross2 } from "react-icons/rx";


const SkillForm = ({ skills, secondarySkill, setSkills, setSecondarySkill, name }) => {

  const handleAddSkill = () => {
    setSkills([...skills, { skill: "" }]);
  };

  const handleRemoveSkill = (index) => {
    const newSkills = skills.filter((_, i) => i !== index);
    setSkills(newSkills);
  };

  const handleChange = (index, field, value) => {
    const newSkills = [...skills];
    newSkills[index][field] = value;
    setSkills(newSkills);
  };


  const handleAddSecondarySkill = () => {
    setSecondarySkill([...secondarySkill, { sSkill: "" }]);
  };

  const handleRemoveSecondarySkill = (index) => {
    const newSkills = secondarySkill.filter((_, i) => i !== index);
    setSecondarySkill(newSkills);
  };

  const handleChangeSecondary = (index, field, value) => {
    const newSkills = [...secondarySkill];
    newSkills[index][field] = value;
    setSecondarySkill(newSkills);
  };

  return (
    <Box>
      <Box className={styles.employer_details}>
        <Typography sx={{ color: customTextColor, marginBottom: "10px" }}>
          Add Primary Skill of {name}
        </Typography>


        <Grid
          container
          className={styles.candidate_field_section}
          spacing={2}
        >
          {skills.map((skill, index) => (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={3.4}
                lg={3.4}
                sx={{ padding: "5px", position: "relative" }}
                key={index}
              >
                <TextField
                  id={`skill-${index}`}
                  label="Primary Skill"
                  variant="standard"
                  sx={{ width: "100%" }}
                  value={skill.skill}
                  onChange={(e) => handleChange(index, "skill", e.target.value)}
                />
              </Grid>
              {skills.length > 1 && (
                <Grid item xs={12} md={0.6} sx={{ display: 'flex', alignItems: 'center', paddingTop: '0 !important' }}>
                  <RxCross2
                    onClick={() => handleRemoveSkill(index)}
                    style={{
                      // fontSize: "80px",
                      cursor: "pointer",
                    }} />
                </Grid>
              )}
            </>
          ))}
        </Grid>


        <button
          variant="contained"
          className={styles.add_more_skill_btns}
          onClick={handleAddSkill}
        >
          Add More Skill
        </button>
      </Box>
      <Box className={styles.employer_details}>
        <Typography sx={{ color: customTextColor, marginBottom: "10px" }}>
          Add Secondary Skill of {name}
        </Typography>


        <Grid
          container
          className={styles.candidate_field_section}
          spacing={2}
        >
          {secondarySkill.map((skill, index) => (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={3.4}
                lg={3.4}
                sx={{ padding: "5px", position: "relative" }}
                key={index}
              >
                <TextField
                  id={`skill-${index}`}
                  label="Secondary Skill"
                  variant="standard"
                  sx={{ width: "100%" }}
                  value={skill.sSkill}
                  onChange={(e) => handleChangeSecondary(index, "sSkill", e.target.value)}
                />
              </Grid>

              {secondarySkill.length > 1 && (
                <Grid item xs={12} md={0.6} sx={{ display: 'flex', alignItems: 'center', paddingTop: '0 !important' }}>
                  <RxCross2
                    onClick={() => handleRemoveSecondarySkill(index)}
                    style={{
                      // fontSize: "80px",
                      cursor: "pointer",
                    }} />
                </Grid>
              )}
            </>
          ))}
        </Grid>


        <button
          variant="contained"
          className={styles.add_more_skill_btns}
          onClick={handleAddSecondarySkill}
        >
          Add More Skill
        </button>
      </Box>
    </Box>
  );
};

export default SkillForm;
